import React, { Component } from 'react';
import { Layout, Row, Col } from 'antd';
import { RTLCol } from '../RTLKit';
import SideNavigation from './parts/SideNavigation';
import UserMenu from './parts/UserMenu';
import { Link } from 'react-router-dom';
const {
    Header, Footer, Content,
} = Layout;


export default class AppLayout extends Component {
    render() {
        const { children } = this.props;


        return (
            <div>
                <Layout style={{ minHeight: '100vh' }}>
                    {(this.props.isLogin)
                    ?
                        <Header style={{ padding: 0, backgroundColor: '#FDFDFD' }}>
                            <Row type="flex" justify="end" align="middle">
                                <RTLCol md={3} sm={12} xs={24}>
                                    <Link to="/">
                                        <div className="logo-box">
                                            <div className="logo"></div>
                                        </div>
                                    </Link>
                                </RTLCol>
                                <RTLCol md={21} sm={12} xs={24} style={{textAlign: 'left', paddingLeft: '15px'}}>
                                    <UserMenu/>
                                </RTLCol>
                            </Row>
                        </Header>
                    :
                    null}
                    <Layout>
                        {(this.props.isLogin) ? <SideNavigation /> :null}
                        <Layout>
                            <Content style={{padding: '10px'}}>{children}</Content>
                            {(this.props.isLogin)
                             ?
                                <Footer style={{backgroundColor: '#F7F7F7'}}>Abci Platform &copy;2019</Footer>
                             :null}
                        </Layout>
                    </Layout>
                </Layout>
            </div>
        );
    }
}
